import { render, staticRenderFns } from "./AdsAddPage.vue?vue&type=template&id=1f99f367&scoped=true&"
import script from "./AdsAddPage.vue?vue&type=script&lang=js&"
export * from "./AdsAddPage.vue?vue&type=script&lang=js&"
import style0 from "./AdsAddPage.vue?vue&type=style&index=0&id=1f99f367&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f99f367",
  null
  
)

export default component.exports